export default __webpack_public_path__ + "static/media/i224hp.22a0219b.webp";